<template>
    <button type="button" class="btn-custom ff-semi">
        <img src="@/module/Bitkub/assets/bitkub_logo.svg" class="mr-1 inline-block" />
        <span>
            <slot></slot>
        </span>
    </button>
</template>
<script>
export default {
    name: 'BitkubConnectButton',
}
</script>

<style lang="scss" scoped>
.btn-custom {
    height: 40px;
    background-color: #27d87d;
    border-radius: 40px;
    font-weight: 600;
    color: #fff;
    outline: none;
    appearance: none;
    font-size: 15px;
    border: none;
    outline: none;
    padding-left: 28px;
    padding-right: 28px;
    line-height: 0;

    & > *{
        vertical-align: middle;
    }

    &.disabled {
        background-color: #eaeaea;
        color: #aaaaaa;
    }
}
</style>
